/**
*
* Heading
* @deprecated
*/

import React from 'react';
import { string } from 'prop-types';
import styled from 'styled-components';
import Container from '../Container';

const StyledHeading = styled.section`

`;

function Heading(props) {
  const { title } = props;
  return (
    <StyledHeading>
      <Container>
        <h1>{title}</h1>
      </Container>
    </StyledHeading>
  );
}

Heading.propTypes = {
  title: string,
};
Heading.defaultProps = {
  title: '',
};

export default Heading;



// WEBPACK FOOTER //
// client/components/Heading/index.js